import adminIndex from "../../../components/adminIndex.module.css";
import * as React from "react";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import dayjs from "dayjs";
import { getChipProps } from "../../../../customer/utils/getChipProps";
import VerifyTransactionModal from "./VerifyTransactionModal";

import { useSelector } from "react-redux";
import { transactionSelector } from "../../../../../redux/slices/transactionSlice";

// Same three types as before (withdrawal, refund, deposit), as tinted line icons.
const paymentTypeIcons = {
  withdrawal: { bg: "#f1f1f1", color: "#303030", path: <><path d="M12 19V5" /><path d="m5 12 7-7 7 7" /></> },
  refund: { bg: "#efe6ff", color: "#5700d1", path: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /></> },
  deposit: { bg: "#e0f0ff", color: "#00527c", path: <><path d="M12 5v14" /><path d="m5 12 7 7 7-7" /></> },
};

function PaymentTypeIcon({ transactionFor }) {
  const type =
    transactionFor === "Order Fulfillment" || transactionFor === "Manual Withdraw"
      ? "withdrawal"
      : transactionFor === "Refund Balance"
      ? "refund"
      : "deposit";
  const { bg, color, path } = paymentTypeIcons[type];
  return (
    <span
      aria-hidden="true"
      style={{ width: 28, height: 28, borderRadius: 8, background: bg, color, display: "inline-flex", alignItems: "center", justifyContent: "center", flex: "none" }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {path}
      </svg>
    </span>
  );
}

function Row(props) {
  const { row,tabStatus } = props;
  const shouldBold = { fontWeight: "bold" };

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          borderBottom: "1px solid #ebebeb",
          width: "100%",
          "&:hover": {
            backgroundColor: "rgba(244,244,244,.5)",
          },
        }}
      >
        <TableCell sx={{...shouldBold, width:"205px"}}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <PaymentTypeIcon transactionFor={row?.transaction_for} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#303030" }}>
                {row.transaction_for}
              </div>
              <div style={{ fontSize: 12.5, color: "#616161", marginTop: 2, textTransform: "capitalize" }}>
                {row?.transaction_type?.toLowerCase().replace(/_/g, " ")}
              </div>
            </div>
          </div>
        </TableCell>
        {/* <TableCell sx={shouldBold}>{row?.payment_method}</TableCell> */}
        <TableCell sx={shouldBold}>
          {row?.transaction_id || "Not available"}
        </TableCell>
        <TableCell sx={shouldBold}>{row?.store?.store_name}</TableCell>
        <TableCell sx={shouldBold}>
          {" "}
          {row?.user?.first_name + " " + row?.user?.last_name}
        </TableCell>
        <TableCell sx={shouldBold}> {row?.user?.email}</TableCell>

        <TableCell sx={shouldBold}>
          {" "}
          {dayjs(row?.createdAt).format("YYYY-MM-DD")}
        </TableCell>
        <TableCell sx={shouldBold}>
          €
          {row?.amount !== 0
            ? row?.amount?.toFixed(2)
            : row?.verified_amount
            ? row?.verified_amount?.toFixed(2)
            : row?.refund_amount || 0}
        </TableCell>
        <TableCell align="center">
          <div style={{ display: "flex", justifyContent: "center" }}>
            {getChipProps({
              value: row?.status,
              products: row,
              transaction: row,
            })}
          </div>
        </TableCell>
        <TableCell align="right">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {row?.status === "Success" || row?.status === "SUCCESS" ? (
              <div style={{ opacity: "0.3", pointerEvents: "none" }}>
                <VerifyTransactionModal transactionId={row?._id}  />
              </div>
            ) : (
              <div className={adminIndex.iconButton} title="Verify transaction">
                <VerifyTransactionModal transactionId={row?._id} tabStatus={tabStatus} amount={row?.amount}/>
              </div>
            )}
            {/* <Icon
            icon="carbon:trash-can"
            width="20"
            height="20"
            style={{ cursor: "pointer" }}
          /> */}
            {/* <div style={{marginTop:"10px"}}>
          <ConfirmationModal
            icon="delete"
            title="Are you sure you want to delete this transaction?"
            confirm="Delete"
            elementId={row}
          />
          </div> */}
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
export default function AdminPaymentDataTable({ transactions, tabStatus }) {
  const {isLoading} = useSelector(transactionSelector)
  const tableHeadStyles = {
    color: "#707070",
    fontWeight: 500,
  };
  return (
    <TableContainer
      component={Paper}
      sx={{
        marginTop: "20px",
        // padding: "1% ",
        width: "100%",
        boxShadow: "none",
      }}
    >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow
            sx={{
              background: "#eeeeee",
            }}
          >
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Payment Type
            </TableCell>
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
             Transaction ID
            </TableCell>
            {/* <TableCell align="left" sx={tableHeadStyles}>
              Payment Method
            </TableCell> */}
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Store name
            </TableCell>
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Created By
            </TableCell>
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Email
            </TableCell>

            <TableCell align="left" sx={tableHeadStyles}>
              Date
            </TableCell>
            <TableCell align="left" sx={tableHeadStyles}>
              Amount
            </TableCell>
            <TableCell
              align="center"
              sx={tableHeadStyles}
              // style={{ paddingRight: "16px" }}
            >
              Status
            </TableCell>
            <TableCell
              align="right"
              sx={tableHeadStyles}
              style={{ padding: "12px 16px" }}
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        {!isLoading && <TableBody>
          {transactions?.map((row) => (
            <Row key={row._id} row={row} tabStatus={tabStatus}/>
          ))}
        </TableBody>}
      </Table>
      {isLoading && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress
            sx={{
              marginTop: "50px",
            }}
            disableShrink
          />
        </div>
      )}
    </TableContainer>
  );
}
